<script setup>
import { VueFinalModal } from "vue-final-modal";
import { computed, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Keyboard, Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
import { useModalsStore } from "@/stores/showModals";
import { getGalleryImages } from "@/data/galleries";

const modalStore = useModalsStore();
const galleryImages = computed(() => getGalleryImages(modalStore.showCountryModal));


onMounted(async () => { });

//eslint-disable-next-line
const onSwiper = (swiper) => {
    //   console.log(swiper);
};

const onSlideChange = (swiper) => {
    //eslint-disable-next-line
    const activeSlideIndex = swiper.activeIndex;
    //Slider que esta activo
    //   console.log("Slide change: " + activeSlideIndex);
};

const modules = [Keyboard, Autoplay, Pagination, Navigation, EffectFade];





</script>

<template>
    <VueFinalModal class="gallery-modal" content-class="gallery-modal-content   flex justify-center items-center"
        overlay-transition="vfm-fade" content-transition="vfm-fade" lock-scroll="true">
        <div class=" text-black ">
            <div class="flex w-full justify-center items-center relative">
                <div class=" flex items-center container-slide justify-center">
                    <button class="button-prev invert z-10">
                        <svg class=" -rotate-90" xmlns="http://www.w3.org/2000/svg" width="14.974" height="17.746"
                            viewBox="0 0 14.974 17.746">
                            <g id="Grupo_131" data-name="Grupo 131" transform="translate(-7430.874 -2098.879)">
                                <g id="Grupo_11" data-name="Grupo 11">
                                    <g id="Grupo_10" data-name="Grupo 10">
                                        <path id="Trazado_14" data-name="Trazado 14"
                                            d="M7438.072,2098.959a.558.558,0,0,1,.576,0l6.8,3.744c.18.108.4.252.4.468v4.535c0,.288-.216.5-.4.4l-7.092-4.033-7.09,4.033c-.18.107-.4-.109-.4-.4v-4.535c0-.216.216-.36.4-.468Zm0,8.5a.556.556,0,0,1,.576,0l6.8,3.743c.18.109.4.252.4.469v4.535c0,.288-.216.5-.4.4l-7.092-4.031-7.09,4.031c-.18.108-.4-.108-.4-.4v-4.535c0-.217.216-.36.4-.469Z"
                                            fill="#fff" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <div class="z-10 flex  w-full justify-center items-center">
                        <swiper :spaceBetween="20" :modules="modules" :loop="true" :autoplay="{
                            delay: 3500 * 1000,
                            disableOnInteraction: true,
                        }" :navigation="{
                            nextEl: '.button-next',
                            prevEl: '.button-prev',
                        }" :breakpoints="{
                            '@0.25': {
                                slidesPerView: 1,
                                spaceBetween: 20,
                                loop: true,
                                slidesPerGroup: 1,
                            },
                            '@0.50': {
                                slidesPerView: 1,
                                spaceBetween: 20,
                                loop: true,
                                slidesPerGroup: 1,
                            },
                            '@0.75': {
                                slidesPerView: 1,
                                spaceBetween: 20,
                                loop: true,
                                slidesPerGroup: 1,
                            },

                            '@1.00': {
                                slidesPerView: 1,
                                spaceBetween: 10,
                                loop: true,
                            },
                            '@1.50': {
                                slidesPerView: 2,
                                spaceBetween: 10,
                                loop: true,

                            },
                        }" :speed="400" :key="modalStore.showCountryModal" @swiper="onSwiper" @slideChange="onSlideChange" class="mySwiper w-full ">
                            <swiper-slide v-for="image in galleryImages" :key="image">
                                <div
                                    class=" activity-container w-full h-full flex flex-col items-center justify-between">
                                    <img :src="image"
                                        class="image-slide" alt="" />
                                </div>
                             </swiper-slide>
                        </swiper>

                    </div> <button class="button-next invert z-10">
                        <svg class=" rotate-90" xmlns="http://www.w3.org/2000/svg" width="14.974" height="17.746"
                            viewBox="0 0 14.974 17.746">
                            <g id="Grupo_131" data-name="Grupo 131" transform="translate(-7430.874 -2098.879)">
                                <g id="Grupo_11" data-name="Grupo 11">
                                    <g id="Grupo_10" data-name="Grupo 10">
                                        <path id="Trazado_14" data-name="Trazado 14"
                                            d="M7438.072,2098.959a.558.558,0,0,1,.576,0l6.8,3.744c.18.108.4.252.4.468v4.535c0,.288-.216.5-.4.4l-7.092-4.033-7.09,4.033c-.18.107-.4-.109-.4-.4v-4.535c0-.216.216-.36.4-.468Zm0,8.5a.556.556,0,0,1,.576,0l6.8,3.743c.18.109.4.252.4.469v4.535c0,.288-.216.5-.4.4l-7.092-4.031-7.09,4.031c-.18.108-.4-.108-.4-.4v-4.535c0-.217.216-.36.4-.469Z"
                                            fill="#fff" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </VueFinalModal>
</template>

<style scoped>
.button-next svg,
.button-prev svg {
    fill: #fff;
    width: 30px;
    height: 30px;
    padding: 0px 5px;
}

.image-slide {
    height: 25rem;
    width: auto;
    object-fit: contain;
}

.container-slide {
    width: 75vw;
}

.container-social {
    border-radius: 0.8rem;
}

.icon-social {
    width: 25px;
    height: 25px;
    margin-right: 5px;
    filter: invert(1);
}

.btn-social span {
    margin-bottom: -3px;
}

.btn-social:hover .icon-social {
    filter: initial;
}

.btn-social {
    border-radius: 5px;
}



/* Pantallas grandes */
@media (min-width: 1500px) {}

/* PC */
@media (min-width: 992px) and (max-width: 1499px) {}

/* Tablet */
@media (min-width: 768px) and (max-width: 991px) {
    .btn-social {
        padding: 0.8rem 1.5rem 0.8rem 1.5rem;
    }

    .text-title {
        font-size: 35px;
    }

    .md\:w-80 {
        width: 36rem !important;
    }

    .btn-social span {
        margin-bottom: -3px;
        font-size: 12px !important;
    }

    .text-goat {
        font-size: 30px;
    }

}

/* Mobile */
@media (max-width: 767px) {
    .grid-cols-4 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .btn-social span {
        margin-bottom: -3px;
        font-size: 13px !important;
    }

    .text-title {
        font-size: 30px !important;
    }


}
</style>
